import {CLStore} from 'common/src/redux/store';
import getActiveComp from './getActiveComp';

export default function getSelectedLayerIndexes(store: CLStore): number[] {
  const activeComp = getActiveComp(store);

  const activeLayerIds = store.getState().creativeTemplatePage.formatMovies.activeLayerIds;

  if (!activeComp) {
    return [];
  }

  return (
    activeLayerIds
      .map((id) => activeComp.l.find((l) => l.id === id))
      .filter((t) => !!t)
      .map((layer) => parseInt(layer.i)) ?? []
  );
}
